<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="kreditgenie-text-green hover:kreditgenie-text-green-hover" :href="route('widgets')">Widgets</inertia-link>
      <span class="kreditgenie-text-green font-medium">/</span> Erschaffen
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.title" :error="form.errors.title" class="pr-6 pb-8 w-full lg:w-full" label="Titel" />

          <quill-editor
            ref="myQuillEditor"
            v-model="form.content"
            :error="form.errors.content"
            class="pr-6 pb-8 mb-8 w-full lg:w-full"
            label="Inhalt"
          />

          <file-input v-model="form.photo" :error="form.errors.photo" class="pr-6 pb-8 w-full lg:w-1/2" type="file" accept="image/*" label="Foto" />
          <select-input v-model="form.status" :error="form.errors.status" class="pr-6 pb-8 w-full lg:w-1/2" label="Status">
            <option value="draft" selected>Entwurf</option>
            <option value="publish">Veröffentlichen</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-green" type="submit">Erschaffen</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import FileInput from '@/Shared/FileInput'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  metaInfo: { title: 'Widget Erschaffen' },
  components: {
    quillEditor,
    SelectInput,
    LoadingButton,
    TextInput,
    FileInput,
  },
  layout: Layout,
  props: {
    tinyMceApiKey: String,
  },
  remember: 'form',
  data() {
    return {
      editor: null,
      form: this.$inertia.form({
        title: null,
        content: null,
        status: null,
        category: null,
        photo: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('widgets.store').url())
    },
  },
}
</script>

